/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import Types from '../constants/actionTypes';

const initialState = {
  isFetching: false,
  isSending: false,
  goal: { id: 0 },
  goals: []
};

const goalReducer = (state = initialState, action) => {
  switch (action.type) {
    case Types.REQUEST_GOAL:
      return Object.assign({}, state, {
        isSending: true,
        isFetching: true
      });
    case Types.RECEIVE_GOALS:
      return Object.assign({}, state, {
        isFetching: false,
        goals: action.goals
      });
    case Types.SET_GOAL:
      return Object.assign({}, state, {
        isFetching: false,
        nogoal: false,
        goal: action.goal
      });
    case Types.SEND_GOAL:
      return { ...state, isSending: true };
    case Types.CLEAR_ACTIVE_SPINNER:
      return { ...state, isFetching: false, isSending: false }
    default:
      return state;
  }
};

export default goalReducer;
